import React from 'react'

import { Provider } from './Context'
import { Layout } from './Layout'

export const DateTimeZoneWidget = (props) => {
  return (
    <Provider {...props}>
      <Layout />
    </Provider>
  )
}
